import { config } from "src/stateManagement/redux/configVar";

export const requestDataFromAnalyzer = async (body: any): Promise<any> => {

    try {
        const serverUrl = config.analyzer;

        const response = await fetch(
            `${serverUrl}/analysis/getFillageLine`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(body)
            }
        );

        if (response?.status !== 200 && response?.status !== 201) {
            return false;
        }

        const data = await response.json();

        return data;
    } catch (error) {
        return false;
    }


}